import type { RouteLocationNormalized, Router } from "vue-router";

export const recruitmentRequestRouteName = {
  index: "recruitment-requests.index",
  show: "recruitment-requests.show",
  log: "recruitment-requests.log",
  testAndInterview: "recruitment-requests.test-and-interview",
  document: "recruitment-requests.document",
  ptkDocument: "recruitment-requests.ptk.document",
};

export const recruitmentRequestRoute = [
  {
    path: "/recruitment-requests",
    name: recruitmentRequestRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_request",
      breadcrumbs: () => {
        return [{ title: "Recruitment Request" }];
      },
    },
  },
  {
    path: "/recruitment-requests/:id",
    name: recruitmentRequestRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_request",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: recruitmentRequestRouteName.index }).path, title: "Recruitment Request" }, { title: "Detail" }];
      },
    },
  },
  {
    path: "/recruitment-requests/:id/ptk/document",
    name: recruitmentRequestRouteName.ptkDocument,
    component: () => import("../pages/PtkDocumentPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "none",
      menu: "recruitment_request",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: recruitmentRequestRouteName.index }).path, title: "Recruitment Request" }, { title: "PTK" }];
      },
    },
  },
];
